import React, { useState, useMemo, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './Css/Directory.css';
import { Row, Col, Card, Button, Container, Image, Badge, Modal, Carousel, OverlayTrigger, Tooltip } from "react-bootstrap";
import { BsClock, BsClockFill, BsClockHistory, BsCloudCheckFill, BsGeoAltFill, BsStarFill, BsBookmarkFill, BsBookmark } from "react-icons/bs";
import { useNavigate } from 'react-router-dom';
// import dummyImage from '../dummy.jpg';
import AdSlider from '../Components/AdSlider';
import { FaStar, FaCar, FaSnowflake, FaTruck, FaVideo, FaWheelchair, FaCouch, FaWifi, FaHourglassHalf,
  FaAmbulance, FaCalendarAlt, 
  FaVideoSlash, FaShoppingBag, FaLaptop, FaHospital, FaLightbulb, 
  FaUsers, FaTree, FaBed, FaSwimmingPool, FaHandsHelping, FaTrash, 
  FaUtensils, FaLeaf, FaWater, FaDonate, FaMoon, FaFirstAid, 
  FaNotesMedical, FaPills, FaHandHoldingMedical, FaRunning, FaBabyCarriage, 
  FaBookOpen, FaBuilding, FaVial, FaPhone, FaTools, FaHeart,
  FaYoutube,FaHandSparkles ,FaShieldAlt,FaMapMarkerAlt,
 } from 'react-icons/fa';
import { TiTick } from "react-icons/ti";
import { MdVerified } from "react-icons/md";
import { GiLaurelsTrophy, GiTrophy } from "react-icons/gi";
import { useEngagementGate } from "../hooks/useEngagementGate";
import { useAuth } from "../contexts/AuthContext";
import AuthGateModal from "../hooks/AuthGateModel";
import StarRating from "../Components/StarRating";
import { Helmet } from 'react-helmet-async';
import ReactPaginate from "react-paginate";
import petFriendlyRestaurantImg from "../assets/dummies/pet-friendly-restaurant.jpg";
import petSpaImg from "../assets/dummies/pet-spa.jpg";
import petFriendlyCafeImg from "../assets/dummies/pet-friendly-cafe.jpg";
import petSitterImg from "../assets/dummies/pet-sitter.jpg";
import dayCareImg from "../assets/dummies/day-care.jpg";
import petBoardingImg from "../assets/dummies/pet-boarding.jpg";
import petTaxiImg from "../assets/dummies/pet-taxi.jpg";
import forSaleImg from "../assets/dummies/for-sale.jpg";
import care247Img from "../assets/dummies/care-247.jpg";
import vetHospitalImg from "../assets/dummies/veterinary-hospital.jpg";
import groomingImg from "../assets/dummies/grooming.jpg";
import petRelocationImg from "../assets/dummies/pet-relocation.jpg";
import dogTrainingImg from "../assets/dummies/dog-training.jpg";
import defaultImg from "../dummy.jpg";
import Loader from '../Components/Loader';

// Example data (replace with API data)


const API_BASE =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_API_URL
    : "http://localhost:5000";

const categoryDummyImages = {
  "pet friendly restaurant": petFriendlyRestaurantImg,
  "pet spa": petSpaImg,
  "pet friendly cafe": petFriendlyCafeImg,
  "pet sitter": petSitterImg,
  "day care centre": dayCareImg,
  "pet boarding services": petBoardingImg,
  "pet taxi": petTaxiImg,
  "for sale": forSaleImg,
  "24/7 care": care247Img,
  "veterinary hospital": vetHospitalImg,
  "grooming": groomingImg,
  "pet relocation": petRelocationImg,
  "dog training" : dogTrainingImg,
};
const AMENITY_ICONS = {
  // Existing & Mapped Icons
  "Parking": <FaCar />,
  "Parking Available": <FaCar />,
  "Air Conditioning": <FaSnowflake />,
  "Air-Conditioned Facility": <FaSnowflake />,
  "Air-Conditioned Rooms": <FaSnowflake />,
  "Air-Conditioned Vehicle": <FaSnowflake />,
  "Pickup & Drop Available": <FaTruck />,
  "Home Pickup & Drop": <FaTruck />,
  "Home Delivery": <FaTruck />,
  "Same-Day Delivery": <FaTruck />,
  "Online Consultations": <FaVideo />,
  "Online Consultation Available": <FaVideo />,
  "Wheelchair Accessible": <FaWheelchair />,
  "Pet Friendly": <FaCouch />,
  "Pets Allowed Indoors": <FaCouch />,
  "Pets Allowed Outdoors": <FaTree />,
  "WiFi": <FaWifi />,
  "Wifi accessible": <FaWifi />,
  "Waiting Area": <FaHourglassHalf />,

  // New Amenities Icon Mapping
  "24x7 Emergency Care": <FaAmbulance />,
  "24x7 Staff Supervision": <FaShieldAlt />,
  "24x7 Transit Support": <FaMapMarkerAlt />,
  "Ambulance Available": <FaAmbulance />,
  "Appointment Required": <FaCalendarAlt />,
  "CCTV Monitoring": <FaShieldAlt />,
  "Donation Facility": <FaDonate />,
  "Drinking Water for Pets": <FaWater />,
  "Emergency Vet Contact Support": <FaPhone />,
  "Flexible Scheduling": <FaCalendarAlt />,
  "Food & Water Bowls Provided": <FaUtensils />,
  "Foster Network": <FaHandsHelping />,
  "GPS Tracking": <FaMapMarkerAlt />,
  "Group Classes": <FaUsers />,
  "Home Training Available": <FaRunning />,
  "Home Visit Available": <FaCar />,
  "Hydrotherapy Equipment": <FaWater />,
  "Hygienic Sanitized Equipment": <FaTools />,
  "Hypoallergenic Products": <FaLeaf />,
  "ICU Facility": <FaHospital />,
  "In-house Laboratory": <FaVial />,
  "In-house Pharmacy": <FaPills />,
  "Indoor Play Area": <FaCouch />,
  "Indoor Training Area": <FaRunning />,
  "Leash-Friendly Seating": <FaCouch />,
  "Lighting for Evening Visits": <FaLightbulb />,
  "One-on-One Sessions": <FaUsers />,
  "Online Ordering": <FaShoppingBag />,
  "Online Training Available": <FaLaptop />,
  "Operation Theatre": <FaHospital />,
  "Organic / Natural Products": <FaLeaf />,
  "Outdoor Garden Seating": <FaTree />,
  "Outdoor Play Area": <FaTree />,
  "Outdoor Training Area": <FaTree />,
  "Overnight Stay Available": <FaMoon />,
  "Pet Beds Provided": <FaBed />,
  "Pet Play Area": <FaCouch />,
  "Pet Play Area (Indoor)": <FaCouch />,
  "Pet Play Area (Outdoor)": <FaTree />,
  "Premium Grooming Products": <FaHandSparkles  />, // Or FaStar if sparkles isn't imported
  "Private Spa Rooms": <FaBuilding />,
  "Rescue Shelter": <FaHeart />,
  "Shaded Seating": <FaTree />,
  "Swimming Pool": <FaSwimmingPool />,
  "Therapy Room": <FaNotesMedical />,
  "Travel Insurance Assistance": <FaShieldAlt />,
  "Treats Available": <FaUtensils />,
  "Volunteer Registration": <FaHandsHelping />,
  "Waste Disposal Bins": <FaTrash />
};

// const normalize = (str = "") =>
//   str
//     .toLowerCase()
//     .replace(/&/g, "and")        // fix & vs and
//     // .replace(/[^a-z0-9\s]/g, "") // remove special chars (), / , etc
//     .replace(/-/g, " ")              // convert hyphen → space
// .replace(/[^a-z0-9\s]/g, "")    // remove other chars
//     .replace(/\s+/g, " ")        // normalize spaces
//     .trim();
const normalize = (str = "") =>
  str
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/-/g, " ")
    .replace(/[^a-z0-9\/\s]/g, "") // ✅ allow "/" here
    .replace(/\s+/g, " ")
    .trim();

    const stripSpaces = (str = "") => str.toLowerCase().replace(/[^a-z0-9]/g, "");
const Directory = () => {
    const [loading, setLoading] = useState(true);
  const { user, authLoading  } = useAuth();
  const engagementGate = useEngagementGate(user);
const [showAuthGate, setShowAuthGate] = useState(false);

  const pgname = "directory";
  const navigate = useNavigate();
  // const { city: routeCity, category: routeCategory, pet: routePet } = useParams();
  const params = useParams();

// const routeCity = params.city ? decodeURIComponent(params.city) : "";
// const routeCategory = params.category ? decodeURIComponent(params.category) : "";
// const routePet = params.pet ? decodeURIComponent(params.pet) : "";
const routeCity =
  params.city && params.city !== "all"
    ? normalize(decodeURIComponent(params.city))
    : "";

const routeCategory =
  params.category && params.category !== "all"
    ? normalize(decodeURIComponent(params.category))
    : "";

const routePet =
  params.pet && params.pet !== "all"
    ? normalize(decodeURIComponent(params.pet))
    : "";

  const [selectedCity, setSelectedCity] = useState('');
  const [selectedCategory, setSelectedCategory] = useState(routeCategory || '');
  const [selectedAmenity, setSelectedAmenity] = useState(''); // ✅ NEW: Amenity Filter State
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [topHomeAds, setTopHomeAds] = useState([]);
    const [bottomHomeAds, setBottomHomeAds] = useState([]);
    const [middleHomeAds, setMiddleHomeAds] = useState([]);
    const [topCityAds, setTopCityAds] = useState([]);
const [middleCityAds, setMiddleCityAds] = useState([]);
const [bottomCityAds, setBottomCityAds] = useState([]);
  const [adSettings, setAdSettings] = useState({ slideInterval: 5, maxImages: 5 });
  // const [selectedPet, setSelectedPet] = useState("");
  const [selectedPets, setSelectedPets] = useState([]);
const [petCategories, setPetCategories] = useState([]);
const [quickFilter, setQuickFilter] = useState(""); // topRated | verified
const [sortBy, setSortBy] = useState("relevance");  // relevance | rating | popular | distance
const [minRating, setMinRating] = useState(0);      // 0 | 3.5 | 4 | 4.5 | 5
const [selectedService, setSelectedService] = useState("");
const [savedListingIds, setSavedListingIds] = useState([]);
  const [savingId, setSavingId] = useState(null);

const petCategoriesList = async () => {
  try {
    const res = await fetch(`${API_BASE}/api/pet-category/show`);
    const data = await res.json();
    if (data.success) {
      setPetCategories(data.petCategories);
      // console.log(petCategories);
    }
  } catch (err) {
    console.error("Error fetching pet categories:", err);
  }
};

  // console.log("routeCity:",routeCity);

  


  const [allListings, setAllListings] = useState([]);
//   const allListings = [
//   { id: 1, name: "Name of Pet Shop", type: "Pet Shop", city: "Mumbai", category: "dog", location: "Bandra West, Mumbai", description: "Premium veterinary services for all your pet’s healthcare needs." },
//   { id: 2, name: "Name of Pet Food", type: "Pet Food", city: "Bangalore", category: "cat", location: "Indiranagar, Bangalore", description: "Professional grooming to keep your pets looking their best." },
//   { id: 3, name: "Name of Happy Tails Boarding", type: "Services", city: "Delhi", category: "dog", location: "Gurgaon, Delhi NCR", description: "Luxury pet boarding with spacious accommodations, playtime, and personalized care." },
//   { id: 4, name: "Name of Birdy Care Center", type: "Pet Shop", city: "Chennai", category: "bird", location: "T Nagar, Chennai", description: "Specialized care for your feathered friends." },
//   { id: 5, name: "Fishy Spa", type: "Pet Insurance", city: "Mumbai", category: "fish", location: "Andheri, Mumbai", description: "Aquarium cleaning and fish grooming services." },
//   // ...add more for demo
// ];

// Unique cities and categories for filters
const citiesList = async () => {
        try {
          const res = await fetch(`${API_BASE}/api/city/show`);
          const data = await res.json();
          if (data.success) {
            // console.log("Fetched cities:", data.cities);
            setCities(data.cities);
          }
        } catch (err) {
          console.error("Error fetching cities:", err.message);
        }
      }
      const categoriesList = async () => {
        try {
          const res = await fetch(`${API_BASE}/api/category/show`);
          const data = await res.json();
          if (data.success) {
            // console.log("Fetched categories:", data.categories);
            setCategories(data.categories);
          }
        } catch (err) {
          console.error("Error fetching categories:", err.message);
        }
      }
const [cities, setCities] = useState([]);
const [categories, setCategories] = useState([]);
useEffect(() => {
    citiesList();
    categoriesList();
    petCategoriesList();
  }, []);


const PAGE_SIZE = 21;

  // Filtered listings
//   const filteredListings = useMemo(() => {
//   const searchLower = search.toLowerCase();

//   // return allListings.filter(l => {
//   //   const cat = l.categories?.[0]?.categoryName?.toLowerCase() || "";
//   //   const cityName = l.city?.city?.toLowerCase() || "";
//   //   const shop = l.shopName?.toLowerCase() || "";
//   //   const pet = l.petCategories?.[0]?.categoryName?.toLowerCase() || "";  

//   //   return (
//   //     (!selectedCategory || cat === selectedCategory.toLowerCase()) &&
//   //     (!selectedCity || cityName === selectedCity.toLowerCase()) &&
//   //     (!routePet || pet === routePet.toLowerCase()) &&
//   //     (shop.includes(searchLower) ||
//   //       cat.includes(searchLower) ||
//   //       pet.includes(searchLower) ||
//   //       cityName.includes(searchLower))
//   //   );

//   // });
//   return allListings.filter(l => {
//     const cat = (l.categories?.[0]?.categoryName || "").toLowerCase();
//     const cityName = (l.city?.city || "").toLowerCase();
//     // const pet = (l.petCategories?.[0]?.categoryName || "").toLowerCase();
//     const petNames = (l.petCategories || [])
//   .map(p => p.categoryName.toLowerCase());
//     const shop = (l.shopName || "").toLowerCase();

//     const categoryMatch =
//       !selectedCategory ||
//       selectedCategory.toLowerCase() === "all" ||
//       cat === selectedCategory.toLowerCase();

//     const cityMatch =
//       !selectedCity ||
//       selectedCity.toLowerCase() === "all" ||
//       cityName === selectedCity.toLowerCase();

//     const petMatch =
//       !search ||
//       search.toLowerCase() === "all" ||
//         petNames.some(p => p.includes(searchLower));

//     const searchMatch =
//       shop.includes(searchLower) ||
//       cat.includes(searchLower) ||
//       petNames.some(p => p.includes(searchLower));
//       cityName.includes(searchLower);

//     return categoryMatch && cityMatch && petMatch && searchMatch;
//   });

// }, [allListings, selectedCategory, selectedCity, routeCity, routeCategory, routePet, search]);

const filteredListings = useMemo(() => {
  const searchLower = search.toLowerCase();
  const searchStripped = stripSpaces(search); 

  let result = allListings.filter(l => {
    // const category = (l.categories?.[0]?.categoryName || "").toLowerCase();
    // const city = (l.city?.city || "").toLowerCase();
    // const category = normalize(l.categories?.[0]?.categoryName);
    const category = (l.categories || []).map(c =>
  normalize(c.categoryName)
);
const city = normalize(l.city?.city);
    const shop = (l.shopName || "").toLowerCase();
    const address = (l.address || l.location || "").toLowerCase(); // Listing address/location
    const rating = Number(l.rating || 0);

    const petNames = (l.petCategories || []).map(p =>
      p.categoryName.toLowerCase()
    );

    const serviceNames = (l.specializedServices || []).map(s =>
      s.serviceName?.toLowerCase()
    );

    // const categoryMatch =
    //   !selectedCategory || category === selectedCategory.toLowerCase();
  //   const categoryMatch =
  // !selectedCategory || category === normalize(selectedCategory);
  const categoryMatch =
  !selectedCategory ||
  (l.categories || []).some(c =>
    normalize(c.categoryName) === normalize(selectedCategory)
  );

    // const cityMatch =
    //   !selectedCity || city === selectedCity.toLowerCase();
    const cityMatch =
  !selectedCity || city === normalize(selectedCity);

    const petMatch =
      !selectedPets.length ||
      (selectedPets.includes("all")
        ? true
        : (l.petCategories || []).some(p =>
            selectedPets
              .map(x => x.toLowerCase())
              .includes(p.categoryName.toLowerCase())
          ));

  //   const serviceMatch =
  // !selectedService ||
  // (l.specializedServices || []).some(s =>
  //   //s.serviceName?.toLowerCase() === selectedService.toLowerCase()
  // );
  console.log("Selected:", normalize(selectedService));
  console.log(
    "Services:",
    l.specializedServices?.map(s => normalize(s.serviceName))
  );
  const serviceMatch =
  !selectedService ||
  (l.specializedServices || []).some(s =>
    normalize(s.serviceName).includes(normalize(selectedService))
  );
  const amenityMatch =
        !selectedAmenity ||
        (l.amenities || []).some(a => a.toLowerCase() === selectedAmenity.toLowerCase());

    // const searchMatch =
    //   shop.includes(searchLower) ||
    //   category.includes(searchLower) ||
    //   city.includes(searchLower) ||
    //   petNames.some(p => p.includes(searchLower));
    const searchMatch =
        !search ||
        shop.includes(searchLower) ||
        category.some(c => c.includes(searchLower)) ||
        city.includes(searchLower) ||
        address.includes(searchLower) ||
        petNames.some(p => p.includes(searchLower)) ||
        // Space-insensitive matching logic for addresses/locations (e.g. "anna naga" matches "annanagar")
        stripSpaces(address).includes(searchStripped) ||
        stripSpaces(shop).includes(searchStripped) ||
        stripSpaces(city).includes(searchStripped);

    const ratingMatch = rating >= minRating;

    const quickFilterMatch =
      !quickFilter ||
      (quickFilter === "topRated" && rating >= 4) ||
      (quickFilter === "verified" && l.isVerified === true);

    return (
      categoryMatch &&
      cityMatch &&
      petMatch &&
      searchMatch &&
      ratingMatch &&
      quickFilterMatch &&
      serviceMatch && 
      amenityMatch
    );
  });

  // SORTING
  switch (sortBy) {
    case "rating":
      result.sort((a, b) => (b.rating || 0) - (a.rating || 0));
      break;
    case "popular":
      result.sort((a, b) => (b.views || 0) - (a.views || 0));
      break;
    case "distance":
      result.sort((a, b) => (a.distance || 0) - (b.distance || 0));
      break;
    default:
      break;
  }

  return result;
}, [
  allListings,
  selectedCategory,
  selectedCity,
  selectedPets,
  selectedAmenity,
  search,
  quickFilter,
  sortBy,
  minRating,
  selectedService
]);

  // Pagination
  const totalPages = Math.ceil(filteredListings.length / PAGE_SIZE);
  const paginatedListings = filteredListings.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  // Handlers
  const handleCategoryChange = e => {
    setSelectedCategory(e.target.value);
    setPage(1);
  };
  const handleCityChange = e => {
    setSelectedCity(e.target.value);
    setPage(1);
  };
  const handleSearchChange = e => {
    setSearch(e.target.value);
    setPage(1);
    // console.log("called");
  };
  const handlePageChange = newPage => setPage(newPage);
  const handlePageClick = ({ selected }) => {
    setPage(selected + 1); // because react-paginate is 0-based
  };
  const fetchListings = async () => {
    try {
            setLoading(true);
      const res = await fetch(`${API_BASE}/api/listing/directory/approved`);
      const data = await res.json();
      if(data.success) {
        setAllListings(data.listings);
        // console.log("Listings fetched:", data.listings);
      }
    }
    catch (err) {
      console.error("Error fetching listings:", err);
    }finally {
      setTimeout(() => {
        setLoading(false);
      }, 1500); // optional delay for smooth loader
    }
  }

  const fetchBottomHomeAds = async () => {
  try {
    const res = await fetch(`${API_BASE}/api/ads/bottom/${pgname}`);
    const data = await res.json();

    if (data.success) {
      // Apply the limit here
      const limitedAds = data.ads.slice(0, data.settings.maxImages);

      setBottomHomeAds(limitedAds);
      setAdSettings(data.settings); 
    }
  } catch (err) {
    console.error("Error fetching home ads:", err);
  }
};
const fetchMiddleHomeAds = async () => {
  try {
    const res = await fetch(`${API_BASE}/api/ads/middle/${pgname}`);
    const data = await res.json();

    if (data.success) {
      // Apply the limit here
      const limitedAds = data.ads.slice(0, data.settings.maxImages);

      setMiddleHomeAds(limitedAds);
      setAdSettings(data.settings); 
    }
  } catch (err) {
    console.error("Error fetching home ads:", err);
  }
};
const fetchCityAds = async () => {

  if(!params.city || params.city === "all") return;

  try {

    const citySlug = encodeURIComponent(params.city);

    const res = await fetch(
      `${API_BASE}/api/ads/directory/cityads/show/${citySlug}`
    );

    const data = await res.json();

    if(data.success){

      const ads = data.ads || [];

      setTopCityAds(
        ads.filter(a => a.position === "top")
      );

      setMiddleCityAds(
        ads.filter(a => a.position === "middle")
      );

      setBottomCityAds(
        ads.filter(a => a.position === "bottom")
      );
    }

  } catch(err){
    console.log("City ads error:", err);
  }

};
useEffect(()=>{
 fetchCityAds();
},[params.city]);
    const fetchTopHomeAds = async () => {
  try {
    const res = await fetch(`${API_BASE}/api/ads/top/${pgname}`);
    const data = await res.json();

    if (data.success) {
      // Apply the limit here
      const limitedAds = data.ads.slice(0, data.settings.maxImages);

      setTopHomeAds(limitedAds);
      setAdSettings(data.settings); 
    }
  } catch (err) {
    console.error("Error fetching home ads:", err);
  }
};
useEffect(() => {
  if (!authLoading && !user && engagementGate) {
    setShowAuthGate(true);
  }
}, [authLoading, user, engagementGate]);
useEffect(() => {
  if (user) {
    setShowAuthGate(false);
  }
}, [user]);

const fetchCategoriesByPet = async (petIds) => {
  try {
    const res = await fetch(`${API_BASE}/api/category/directory/byPetCategories`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ petCategories: petIds })
    });

    const data = await res.json();

    if (data.success) {
      setCategories(data.categories);
    }
  } catch (err) {
    console.error(err);
  }
};
useEffect(() => {
  if (!selectedPets.length || selectedPets.includes("all")) {
    categoriesList(); // fallback → show all
  } else {
    // ⚠️ you must send IDs, not names
    const selectedIds = petCategories
      .filter(p => selectedPets.includes(p.categoryName))
      .map(p => p._id);

    fetchCategoriesByPet(selectedIds);
  }
}, [selectedPets]);
const [specializedServices, setSpecializedServices] = useState([]);

const fetchSpecializedServices = async () => {
  try {
    const res = await fetch(`${API_BASE}/api/specialized-service/service/show`);
    const data = await res.json();
    if (data.success) {
      setSpecializedServices(data.services);
    }
    console.log("services", specializedServices);
  } catch (err) {
    console.error(err);
  }
};

useEffect(() => {
  fetchSpecializedServices();
}, []);
const filteredServices = useMemo(() => {
  if (!selectedPets.length && !selectedCategory) return specializedServices;

  return specializedServices.filter(s => {

    // PET MATCH (IDs)
    const petMatch =
  !selectedPets.length ||
  (s.petCategories || []).some(p =>
    selectedPets
      .map(x => x.toLowerCase())
      .includes(p.categoryName?.toLowerCase())
  );

    // CATEGORY MATCH (ID vs name ❌)
  //   const categoryMatch =
  // !selectedCategory ||
  // s.category?.categoryName?.toLowerCase() === selectedCategory.toLowerCase();
  const categoryMatch =
  !selectedCategory ||
  (s.category || []).some(p =>
    p.categoryName
      ?.toLowerCase()
      .includes(selectedCategory.toLowerCase())
  );

    return petMatch && categoryMatch;
  });
}, [selectedPets, selectedCategory, specializedServices]);
const filteredCities = useMemo(() => {
  if (!selectedPets.length && !selectedCategory) return cities;

  const set = new Set();

  allListings.forEach(l => {
    const petMatch =
      !selectedPets.length ||
      (l.petCategories || []).some(p =>
        selectedPets.includes(p.categoryName)
      );

    const categoryMatch =
      !selectedCategory ||
      (l.categories || []).some(c =>
        c.categoryName.toLowerCase() === selectedCategory.toLowerCase()
      );

    if (petMatch && categoryMatch) {
      if (l.city?.city) {
        set.add(l.city.city.toLowerCase());
      }
    }
  });

  return cities.filter(c =>
    set.has(c.city.toLowerCase())
  );
}, [selectedPets, selectedCategory, allListings, cities]);
useEffect(() => {
  if (!selectedCategory) return;

  const exists = categories.some(
    c => c.categoryName === selectedCategory
  );

  if (!exists) {
    setSelectedCategory("");
  }
}, [categories]);
  useEffect(() => {
    fetchListings();
    fetchTopHomeAds();
    fetchBottomHomeAds();
    fetchMiddleHomeAds();
  }, [])

  // New
  useEffect(() => {
    if (user && allListings.length > 0) {
      const saved = allListings
        .filter((listing) =>
          listing.savedBy?.some(
            (id) => id.toString() === user.id.toString() || id === user.id
          )
        )
        .map((listing) => listing._id);
      setSavedListingIds(saved);
    } else {
      setSavedListingIds([]);
    }
  }, [user, allListings]);

  useEffect(() => {
    if (user && allListings.length > 0) {
      const saved = allListings
        .filter((listing) =>
          listing.savedBy?.some(
            (id) => id.toString() === user.id.toString() || id === user.id
          )
        )
        .map((listing) => listing._id);
      setSavedListingIds(saved);
    } else {
      setSavedListingIds([]);
    }
  }, [user, allListings]);

  // Handle Save / Bookmark listing directly from the directory grid
  const handleSaveListing = async (e, listingId) => {
    e.stopPropagation();

    if (!user) {
      setShowAuthGate(true);
      return;
    }

    setSavingId(listingId);

    try {
      const res = await fetch(`${API_BASE}/api/listing/${listingId}/save`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId: user.id,
          userName: user.name,
          userEmail: user.email,
          action: "save_listing",
        }),
      });

      const data = await res.json();

      if (data.success) {
        setSavedListingIds((prev) =>
          data.isSaved
            ? [...prev, listingId]
            : prev.filter((id) => id !== listingId)
        );
      }
    } catch (err) {
      console.error("Error toggling saved state:", err);
    } finally {
      setSavingId(null);
    }
  };

  // Business Open / Closed status evaluator
  const getBusinessStatus = (businessHours) => {
    if (!businessHours || !Array.isArray(businessHours) || businessHours.length === 0) {
      return { status: "UNAVAILABLE", text: "N/A", colorClass: "text-muted", dotClass: "bg-secondary" };
    }

    const now = new Date();
    const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const currentDay = daysOfWeek[now.getDay()];

    const todaySchedule = businessHours.find(
      (b) => b.day?.toLowerCase() === currentDay.toLowerCase()
    );

    if (!todaySchedule || (!todaySchedule.closed && (!todaySchedule.open || !todaySchedule.close))) {
      return { status: "UNAVAILABLE", text: "N/A", colorClass: "text-muted", dotClass: "bg-secondary" };
    }

    if (todaySchedule.closed) {
      return { status: "CLOSED", text: "Closed", colorClass: "text-danger", dotClass: "bg-danger" };
    }

    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const currentTime = `${hours}:${minutes}`;

    const { open, close } = todaySchedule;

    let isOpen = false;
    if (close < open) {
      isOpen = currentTime >= open || currentTime < close;
    } else {
      isOpen = currentTime >= open && currentTime < close;
    }

    if (isOpen) {
      return { status: "OPEN", text: "Open Now", colorClass: "text-success", dotClass: "bg-success" };
    } else {
      return { status: "CLOSED", text: "Closed", colorClass: "text-danger", dotClass: "bg-danger" };
    }
  };
//   useEffect(() => {
//   if (routeCity) setSelectedCity(routeCity);
//   if (routeCategory) setSelectedCategory(routeCategory);
//   if (routePet) setSearch(routePet);
// }, [routeCity, routeCategory, routePet]);

// useEffect(() => {
//   // PET CATEGORY
//   // if (petCategories.length && routePet) {
//   //   if (routePet.toLowerCase() === "all") {
//   //     setSelectedPet("");
//   //   } else {
//   //     const match = petCategories.find(
//   //       p => p.categoryName.toLowerCase() === routePet.toLowerCase()
//   //     );
//   //     setSelectedPet(match ? match.categoryName : "");
//   //   }
//   // }
//   if (petCategories.length && routePet) {
//   if (routePet.toLowerCase() === "all") {
//     setSelectedPets(["all"]);
//   } else {
//     const match = petCategories.find(
//       p => p.categoryName.toLowerCase() === routePet.toLowerCase()
//     );

//     setSelectedPets(match ? [match.categoryName] : []);
//   }
// }
//   // CATEGORY
//   if (categories.length && routeCategory) {
//     if (routeCategory.toLowerCase() === "all") {
//       setSelectedCategory("");
//     } else {
//       const match = categories.find(
//         c => c.categoryName.toLowerCase() === routeCategory.toLowerCase()
//       );
//       setSelectedCategory(match ? match.categoryName : "");
//     }
//   }

//   // CITY
//   if (cities.length && routeCity) {
//     if (routeCity.toLowerCase() === "all") {
//       setSelectedCity("");
//     } else {
//       const match = cities.find(
//         c => c.city.toLowerCase() === routeCity.toLowerCase()
//       );
//       setSelectedCity(match ? match.city : "");
//     }
//   }

//   // PET TYPE / SEARCH STRING
//   if (routePet) {
//     setSearch(routePet.toLowerCase() === "all" ? "" : routePet);
//   }
// }, [routeCity, routeCategory, routePet, categories, cities, petCategories]);
// useEffect(() => {
//   // PET
//   if (petCategories.length && routePet) {
//     const newPet =
//       routePet.toLowerCase() === "all"
//         ? ["all"]
//         : (() => {
//             const match = petCategories.find(
//               p => p.categoryName.toLowerCase() === routePet.toLowerCase()
//             );
//             return match ? [match.categoryName] : [];
//           })();

//     // ✅ prevent loop
//     if (JSON.stringify(newPet) !== JSON.stringify(selectedPets)) {
//       setSelectedPets(newPet);
//     }
//   }

//   // CATEGORY
//   if (categories.length && routeCategory) {
//     const newCategory =
//       routeCategory.toLowerCase() === "all"
//         ? ""
//         : (() => {
//             const match = categories.find(
//               c => c.categoryName.toLowerCase() === routeCategory.toLowerCase()
//             );
//             return match ? match.categoryName : "";
//           })();

//     if (newCategory !== selectedCategory) {
//       setSelectedCategory(newCategory);
//     }
//   }

//   // CITY
//   if (cities.length && routeCity) {
//     const newCity =
//       routeCity.toLowerCase() === "all"
//         ? ""
//         : (() => {
//             const match = cities.find(
//               c => c.city.toLowerCase() === routeCity.toLowerCase()
//             );
//             return match ? match.city : "";
//           })();

//     if (newCity !== selectedCity) {
//       setSelectedCity(newCity);
//     }
//   }

//   // SEARCH
//   const newSearch =
//     routePet && routePet.toLowerCase() !== "all" ? routePet : "";

//   if (newSearch !== search) {
//     setSearch(newSearch);
//   }

// }, [routeCity, routeCategory, routePet, categories, cities, petCategories]);
useEffect(() => {
  if (!petCategories.length || !categories.length || !cities.length) return;

  // run ONLY on first load (important)
  if (page !== 1) return;

  if (routePet) {
    if (routePet.toLowerCase() === "all") {
      setSelectedPets(["all"]);
    } else {
      // const match = petCategories.find(
      //   p => p.categoryName.toLowerCase() === routePet.toLowerCase()
      // );
      const match = petCategories.find(
  p => normalize(p.categoryName) === routePet
);
      setSelectedPets(match ? [match.categoryName] : []);
    }
  }

  if (routeCategory) {
    if (routeCategory.toLowerCase() === "all") {
      setSelectedCategory("");
    } else {
      // const match = categories.find(
      //   c => c.categoryName.toLowerCase() === routeCategory.toLowerCase()
      // );
      const match = categories.find(
  c => normalize(c.categoryName) === routeCategory
);
      setSelectedCategory(match ? match.categoryName : "");
    }
  }

  if (routeCity) {
    if (routeCity.toLowerCase() === "all") {
      setSelectedCity("");
    } else {
      const match = cities.find(
  c => normalize(c.city) === routeCity
);
      setSelectedCity(match ? match.city : "");
    }
  }

}, [routeCity, routeCategory, routePet, petCategories, categories, cities]);


const [banner, setBanner] = useState(null);

const Banner = async () => {
  try {
    const url = routeCity
      ? `${API_BASE}/api/city-banner/name/${routeCity}`
      : `${API_BASE}/api/directory-banner`;

    const res = await fetch(url);

    if (!res.ok) {
      throw new Error("Failed to fetch banner");
    }

    const data = await res.json();
// console.log(data);
    if (data.success) {
      setBanner(data.banner); // ✅ correct
    }
    
  } catch (err) {
    console.error("Banner error:", err.message);
  }
};

useEffect(() => {
  Banner();
}, [routeCity]);

useEffect(() => {
  Banner();
}, [routeCity]);
useEffect(() => {
  if (!localStorage.getItem("entryTime")) {
    localStorage.setItem("entryTime", Date.now());
  }
}, []);
const showServiceFilter =
  (selectedPets.length > 0 || selectedCategory) &&
  filteredServices.length > 0;


  const handleClearFilters = () => {
  // Reset all filters
  setSearch("");
  setSelectedPets([]);
  setSelectedCategory("");
  setSelectedService("");
  setSelectedAmenity(""); 
  setSelectedCity("");
  setQuickFilter("");
  setSortBy("relevance");
  setMinRating(0);
  setPage(1);

  // Navigate to base directory (remove params)
  navigate("/directory");
};
// console.log("all:",allListings)
const hasActiveFilters = useMemo(() => {
  return (
    search ||
    selectedCategory ||
    selectedService ||
    selectedCity ||
    (selectedPets.length && !selectedPets.includes("all")) ||
    quickFilter ||
    sortBy !== "relevance" ||
    minRating > 0 ||
    routeCity ||
    routeCategory ||
    routePet
  );
}, [
  search,
  selectedCategory,
  selectedService,
  selectedCity,
  selectedPets,
  quickFilter,
  sortBy,
  minRating,
  routeCity,
  routeCategory,
  routePet
]);

const getFallbackImage = (listing) => {
  const firstCategory =
    listing.categories?.[0]?.categoryName?.toLowerCase() || "";

  return categoryDummyImages[firstCategory] || defaultImg;
};
  return (
    <>
    {/* <Helmet>
        <title>Pet Services Directory India – Find Vets, Clinics & Pet Care Near You</title>
        <meta
          name="description"
          content="Explore the Vet & Pets directory to find nearby vets, clinics, pet shops, grooming, and services across India for all your pet care needs easily."
        />
    </Helmet> */}
    <Helmet>
      <title>
        {banner?.metaTitle ||
          "Pet Services Directory India – Find Vets, Clinics & Pet Care Near You"}
      </title>

      <meta
        name="description"
        content={
          banner?.metaDescription ||
          "Explore the Vet & Pets directory to find nearby vets, clinics, pet shops, grooming, and services across India."
        }
      />

      <meta
        name="keywords"
        content={banner?.metaKeywords || ""}
      />
    </Helmet>
    <AuthGateModal
  show={showAuthGate}
  onClose={() => setShowAuthGate(false)}
/>
{/* {banner?.images?.length > 0 && (
  <Carousel
    interval={4000}
    fade
    indicators={banner.images.length > 1}
    controls={banner.images.length > 1}
    pause="hover"
  >
    {banner.images.map((img, index) => (
      <Carousel.Item key={img._id || index}>
        <Image
          className="d-block w-100"
          src={`${API_BASE}/${img.image}`}
          alt={img.alt || `Banner ${index + 1}`}
          style={{
            height: "400px",
            objectFit: "cover",
          }}
        />
      </Carousel.Item>
    ))}
  </Carousel>
)} */}
{banner && (
  <>
    {banner.images?.length > 0 ? (
      <Carousel
        fade
        interval={4000}
        controls={banner.images.length > 1}
        indicators={banner.images.length > 1}
      >
        {banner.images.map((img, index) => (
          <Carousel.Item key={img._id || index}>
            <Image
              className="d-block w-100"
              src={`${API_BASE}/${img.image}`}
              alt={img.alt || "Banner"}
              style={{
                height: "400px",
                objectFit: "cover",
              }}
            />
          </Carousel.Item>
        ))}
      </Carousel>
    ) : banner.banners?.length > 0 ? (
      <Carousel
        fade
        interval={4000}
        controls={banner.banners.length > 1}
        indicators={banner.banners.length > 1}
      >
        {banner.banners.map((img, index) => (
          <Carousel.Item key={img._id || index}>
            <Image
              className="d-block w-100"
              src={`${API_BASE}/${img.image}`}
              alt={img.alt || "Banner"}
              style={{
                height: "400px",
                objectFit: "cover",
              }}
            />
          </Carousel.Item>
        ))}
      </Carousel>
    ) : null}
  </>
)}
    {/* {banner?.banner && (
      <Image
        className='img-responsive'
        src={`${API_BASE}/${banner.banner}`}
        alt="Banner"
        style={{ width: "100%", height: "auto", objectFit: "cover" }}
      />
    )} */}

    
    {/* {topHomeAds.length > 0 && (
      <AdSlider ads={topHomeAds} maxImages={adSettings.maxImages} interval={adSettings.slideInterval} />
    )}
    {middleHomeAds.length > 0 && (
      <AdSlider ads={middleHomeAds} maxImages={adSettings.maxImages} interval={adSettings.slideInterval} float={true}
      side="right" />
    )} */}
    {routeCity ? (
  
  topCityAds.length > 0 &&
  <AdSlider
    ads={topCityAds}
    maxImages={adSettings.maxImages}
    interval={adSettings.slideInterval}
  />

) : (

 topHomeAds.length > 0 &&
 <AdSlider
   ads={topHomeAds}
   maxImages={adSettings.maxImages}
   interval={adSettings.slideInterval}
 />

)}
{routeCity ? (

middleCityAds.length > 0 &&
<AdSlider
 ads={middleCityAds}
 maxImages={adSettings.maxImages}
 interval={adSettings.slideInterval}
 float={true}
 side="right"
/>

):(

middleHomeAds.length > 0 &&
<AdSlider
 ads={middleHomeAds}
 maxImages={adSettings.maxImages}
 interval={adSettings.slideInterval}
 float={true}
 side="right"
/>

)}

    
    <section className="directory-inner-section">
      
      <Container>

        <div className="directory-header">
        <h2>
          {/* {console.log("selcat:",selectedCategory)} */}
          All Services Directory
        </h2>
        <p>Browse top-rated pet services by category and city</p>
      </div>
      
      {/* <div className="directory-listings">
        {paginatedListings.length === 0 ? (
          <div className="no-results">No listings found.</div>
        ) : (
          paginatedListings.map(listing => (
            <div className="directory-card" key={listing._id}>
  <div className="directory-card-header">
    <h3>{listing.shopName}</h3>
    <span className="directory-type">
      {listing.petCategories?.[0]?.categoryName}
    </span>
  </div>

  <div className="directory-location">
    {listing.city.city}
  </div>

  <div className="directory-description">{listing.description}</div>

  <button className="view-details-btn">View Details</button>
</div>

          ))
        )}
      </div> */}
      <Row>
        <Col md={3} className='gx-5'>
          <div className="bg-grey  directory-filters sticky-top shadow-sm  rounded p-3" style={{"top": "70px", "zIndex" : "99"}}>
            <Row className=" shadow-sm m-4 rounded  mb-0  ">
            <h5 style={{background: "#eaeaea", padding: "14px", textAlign: "center"}}>Apply Filter</h5>
            
            <div className=' d-flex gap-3 flex-column p-4'>
            <input
              type="text"
              placeholder="Search ..."
              value={search}
              onChange={handleSearchChange}
            />
             
            {/* <select value={selectedPet} onChange={e => {
              setSelectedPet(e.target.value);
              setPage(1);
            }}>
              <option value="">All Pets</option>
              
              {petCategories.map(pet => (
                <option key={pet._id} value={pet.categoryName}>
                  {pet.categoryName}
                </option>
              ))}
            </select> */}
            {/* <select
  onChange={e => {
    const value = e.target.value;

    if (value === "all") {
      setSelectedPets(["all"]);
    } else {
      setSelectedPets([value]);
    }

    setPage(1);
  }}
>
  {/* <option value="">All Pets</option> */}
  {/*<option value="all">All Types</option>
  {petCategories.map(pet => (
    <option key={pet._id} value={pet.categoryName}>
      {pet.categoryName}
    </option>
  ))}
</select> */}
<select
  value={selectedPets[0] || "all"}
  onChange={e => {
    const value = e.target.value;
    setSelectedPets(value === "all" ? ["all"] : [value]);
      setSelectedCategory(""); // ✅ controlled reset
    setPage(1);
  }}
>
  <option value="all">All Types</option>
  {petCategories.map(pet => (
    <option key={pet._id} value={pet.categoryName}>
      {pet.categoryName}
    </option>
  ))}
</select>

            {/* <select value={selectedCategory} onChange={handleCategoryChange}>
              <option value="">All Categories</option>
              {categories.map(cat => (
                <option value={cat.categoryName} key={cat._id}>
                  {cat.categoryName}
                </option>
              ))}
            </select> */}
           <select value={selectedCategory} onChange={handleCategoryChange}>
  <option value="">All Categories</option>
  {categories.map(cat => (
    <option value={cat.categoryName} key={cat._id}>
      {cat.categoryName}
    </option>
  ))}
</select>
{showServiceFilter && (
  <select
    value={selectedService}
    onChange={e => {
      setSelectedService(e.target.value);
      setPage(1);
    }}
  >
    <option value="">All Services</option>

    {filteredServices.map(s => (
      <option key={s._id} value={s.serviceName}>
        {s.serviceName}
      </option>
    ))}
  </select>
)}
{!routeCity && (
              <select value={selectedCity} onChange={handleCityChange}>
  <option value="">All Cities</option>
  {filteredCities.map(c => (
    <option value={c.city} key={c._id}>
      {c.city}
    </option>
  ))}
</select>
            )}
{/* ✅ NEW: Amenities Filter Dropdown */}
                    <select
                      value={selectedAmenity}
                      onChange={e => {
                        setSelectedAmenity(e.target.value);
                        setPage(1);
                      }}
                    >
                      <option value="">All Amenities</option>
                      {Object.keys(AMENITY_ICONS).map(amenity => (
                        <option key={amenity} value={amenity}>
                          {amenity}
                        </option>
                      ))}
                    </select>
          
           

            {hasActiveFilters && (
            <div className="text-center mt-2">
            <Button size="sm" variant="link"
              onClick={handleClearFilters}
            >
              Clear All
            </Button>
          </div>
            )}
            </div>
            
            </Row>
            <Row className='shadow-sm m-4 rounded  mb-0 '>
              <h5 style={{background: "#eaeaea", padding: "14px", textAlign: "center"}}>Quick Filters</h5>
          <div className=' d-flex gap-3 flex-column p-4'>
            <Button
              size="sm"
              variant={quickFilter === "topRated" ? "primary" : "outline-secondary"}
              onClick={() => setQuickFilter("topRated")}
            >
              <FaStar fill="#ff8800" /> Top Rated
            </Button>

            <Button
              size="sm"
              variant={quickFilter === "verified" ? "primary" : "outline-secondary"}
              onClick={() => setQuickFilter("verified")}
            >
              <TiTick /> Verified
            </Button>

            {quickFilter && (
              <Button size="sm" variant="link" onClick={() => setQuickFilter("")}>
                Clear
              </Button>
            )}
          </div>
          
            </Row>
            <Row className='shadow-sm m-4 rounded  mb-0 '>
              <h5 style={{background: "#eaeaea", padding: "14px", textAlign: "center"}}>Sort by</h5>
          <div className=' d-flex gap-3 flex-column p-4'>
            {["relevance", "rating", "popular"].map(type => (
              <Button
                key={type}
                size="sm"
                variant={sortBy === type ? "dark" : "outline-secondary"}
                onClick={() => setSortBy(type)}
              >
                {type.charAt(0).toUpperCase() + type.slice(1)}
              </Button>
            ))}
          </div>
            </Row>
            <Row className='shadow-sm m-4 rounded '>
              
          <h5 style={{background: "#eaeaea", padding: "14px", textAlign: "center"}}>Ratings</h5>
          <div className="d-flex flex-wrap gap-2 p-4">
            {[0, 3, 4, 5].map(r => (
              <Button
                key={r}
                size="sm"
                variant={minRating === r ? "warning" : "outline-secondary"}
                onClick={() => setMinRating(r)}
              >
                {r === 0 ? "Any" : r === 5 ? `${r}` : `${r}+`}
              </Button>
            ))}
          </div>
            </Row>
            
          </div>
          


        </Col>
        <Col md={9} className=' gx-5'>
            <Row className="justify-content-center">
  {/* {paginatedListings.length === 0 ? (
    <div className="no-results mt-5 d-flex align-items-center justify-content-center">
      <span className='stylish-text'>
        <strong>
          <i className='animation text-orange-500'>
            Coming Soon 
          </i>
        </strong>
      </span>
    </div>
  ) : ( */}
  {loading ? (
  <div className="d-flex justify-content-center align-items-center w-100 py-5">
    <Loader />
  </div>
) : paginatedListings.length === 0 ? (
  <div className="no-results mt-5 d-flex align-items-center justify-content-center">
    <span className='stylish-text'>
      <strong>
        <i className='animation text-orange-500'>
          Coming Soon
        </i>
      </strong>
    </span>
  </div>
) : (
    paginatedListings.map(listing => {
      const { text: statusText, colorClass: statusColor } = getBusinessStatus(listing.businessHours);
      const isListingSaved = savedListingIds.includes(listing._id);
      const safeSlug = listing.slug && listing.slug !== "undefined"
        ? listing.slug
        : listing.shopName
            ?.toLowerCase()
            .trim()
            .replace(/\s+/g, "-")
            .replace(/[^a-z0-9-]/g, "");

            {console.log(listing)}

      return(
        <Col key={listing._id} md={4} className="mb-4 d-flex">
  <Card className="provider-card w-100 h-100 d-flex flex-column">

    <Card.Header className="card-top-rated p-0 pos-rel">
      
      <Card.Img
        variant="top"
  //       src={
  //   listing.bannerImage
  //     ? `${API_BASE}/${listing.bannerImage}`
  //     : dummyImage
  // }
  src={
    listing.bannerImage
      ? `${API_BASE}/${listing.bannerImage}`
      : getFallbackImage(listing)
  }
        alt={listing.shopName}
      />
{/* Save / Bookmark Button Indicator */}
                  <Button
                    variant="light"
                    size="sm"
                    className="position-absolute top-0 end-0 m-2 rounded-circle shadow-sm border-0 d-flex align-items-center justify-content-center"
                    style={{ width: "36px", height: "36px", zIndex: 5 }}
                    onClick={(e) => handleSaveListing(e, listing._id)}
                    disabled={savingId === listing._id}
                  >
                    {isListingSaved ? (
                      <BsBookmarkFill style={{ color: "#ff4e00" }} />
                    ) : (
                      <BsBookmark className="text-dark" />
                    )}
                  </Button>

                  {/* Business Open / Closed Status Badge */}
                  <Badge
                    bg="light"
                    className={`position-absolute bottom-0 start-0 m-2 border shadow-sm ${statusColor} font-monospace px-2 py-1`}
                  >
                    ● {statusText}
                  </Badge>

    </Card.Header>

    <Card.Body className="pos-rel d-flex flex-column flex-grow-1">
      <div className='status-updates mt-5 mb-2 d-flex gap-2 align-items-center'>
  {listing.isVerified && (
    <div className='verified-identification'>
      <OverlayTrigger
        placement="top" 
        overlay={<Tooltip id="verified-tooltip">Verified</Tooltip>}
      >
        <span 
          tabIndex="0" 
          className="d-inline-flex align-items-center text-primary icon-badge-hover"
        >
          <MdVerified size={24} />
        </span>
      </OverlayTrigger>
    </div>
  )}

  {listing.rating >= 4 && (
    <div className='top-rated-identification'>
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="top-rated-tooltip">Top Rated</Tooltip>}
      >
        <span 
          tabIndex="0" 
          className="d-inline-flex align-items-center text-warning icon-badge-hover"
        >
          <GiTrophy size={22} />
        </span>
      </OverlayTrigger>
    </div>
  )}
</div>
      {/* <Card.Title title={listing.shopName || ""}>{listing.shopName && listing.shopName.length >10 ? listing.shopName.slice(0,10) + "..." : listing.shopName}</Card.Title> */}
      <Card.Title
  title={listing.shopName}
  style={{
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "200px",
    cursor: "pointer",
    marginTop: "12px",
  }}
>
  {listing.shopName}
</Card.Title>
      {/* <div className="service-tags mt-2">
        
     {listing.petCategories?.length > 0 && (
        listing.petCategories.map((cat, index) => (
          <span key={index} className="badge badge-top-rated">
            {cat.categoryName}
          </span>
        ))
      )}

      </div> */}
      {/* Amenities */}
      <div className='amenities-updates mt-2 mb-2 d-flex gap-2 align-items-center'>
  {listing.amenities?.slice(0, 10).map((amenityName, index) => {
    const icon = AMENITY_ICONS[amenityName];
    if (!icon) return null; // Skip if no matching icon

    return (
      <div key={index} className='amenity-identification'>
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id={`amenity-tooltip-${index}`}>
              {amenityName}
            </Tooltip>
          }
        >
          <span
            tabIndex="0"
            className="d-inline-flex align-items-center icon-badge-hover"
            style={{ 
              cursor: 'pointer', 
              fontSize: '0.9rem',
              color: '#ff4e00' // Custom orange brand color
            }}
          >
            {icon}
          </span>
        </OverlayTrigger>
      </div>
    );
  })}
</div>

      {/* CATEGORY */}
      <div className="service-tags mt-2">
{listing.categories?.map((cat, index) => (
  <span key={index} className="badge badge-popular">
    {cat.categoryName}
  </span>
))}
</div>
{/* ✅ SPECIALIZED SERVICES (GLOBAL) */}
{listing.specializedServices
  ?.filter(s => s.show !== false) // optional safety
  .map((s, i) => (
    <div key={i} className="text-muted small mt-1">
      {/* • {s.serviceName} */}
      <span className='service-tag  bg-warning text-black'>
        {s.serviceName}
      </span>
    </div>
))}
      {/* <div className="service-rating align-items-center d-flex gap-1">
          <span className='align-items-center d-flex' role="img" aria-label="star" style={{"verticalAlign" : "unset"}}> <BsStarFill /> </span> 
          <span className='d-block'>{listing.rating}</span>
      </div> */}
      <div className="service-rating d-flex align-items-center gap-2 mt-2">
        <StarRating 
          rating={listing.rating} 
          reviewCount={listing.reviewCount} 
        />
      </div>
{/* <div className="service-rating align-items-center d-flex gap-2 mt-2">
  {Number(listing.rating) > 0 ? (
    <>
      <BsStarFill color="#ffb400" />
      <span>{Number(listing.rating).toFixed(1)}</span>
    </>
  ) : (
    <span className="text-muted small">No reviews yet</span>
  )}
</div> */}
      

      {/* <Card.Text className="mt-2">
        {listing.description.length > 50
          ? listing.description.slice(0, 50) + "..."
          : listing.description}
      </Card.Text> */}
      <Card.Text
        className="mt-2"
        title={listing.description}
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,   // number of lines
          WebkitBoxOrient: "vertical",
          cursor: "pointer",
        }}
      >
        {listing.description}
      </Card.Text>

      <div className="service-location mt-2 d-flex gap-2 align-items-center">
        <BsGeoAltFill /> {listing.city.city}
      </div>
      {/* <div className="service-location mt-2">
        {listing.businessHours?.map((bh, index) => (
          <div key={index}>
            <strong>{bh.day}:</strong>{" "}
            {bh.closed ? "Closed" : `${bh.open} - ${bh.close}`}
          </div>
        ))}
      </div> */}
      {/* <div className="service-location mt-2">
  <BsGeoAltFill />{" "}
  {listing.businessHours
    ?.map((bh) =>
      bh.closed ? `${bh.day}: Closed` : `${bh.day}: ${bh.open}-${bh.close}`
    )
    .join(", ")}
</div> */}
{/* <div className="service-location mt-2 d-flex gap-2 align-items-center">
  <BsClockFill /> 
  {(() => {
    const today = new Date().toLocaleString("en-US", { weekday: "long" });

    const todayHours = listing.businessHours?.find(
      (bh) => bh.day === today
    );

    return todayHours
      ? todayHours.closed
        ? "Closed Today"
        : `Open Today: ${todayHours.open} - ${todayHours.close}`
      : "Hours not available";
  })()}
</div> */}
<div className="service-location mt-2 d-flex gap-2 align-items-center">
  <BsClockFill /> 
  {(() => {
    const today = new Date().toLocaleString("en-US", { weekday: "long" });

    const todayHours = listing.businessHours?.find(
      (bh) => bh.day === today
    );

    if (!todayHours) return "Hours not available";

    if (todayHours.closed) return "Closed Today";

    // 🔥 FIX: check empty time
    if (!todayHours.open || !todayHours.close) {
      return "Hours not available";
    }

    return `Open Today: ${todayHours.open} - ${todayHours.close}`;
  })()}
</div>

      {/* <div className="service-tags mt-2">
        {listing.categories?.map((cat, index) => (
          <span key={index} className="service-tag tag-orange">
            {cat.categoryName}
          </span>
        ))}
      </div> */}

      {/* {listing.rating && (
        <div className="service-rating d-flex gap-2 mt-2">
          <BsStarFill />
          <span>{listing.rating}</span>
        </div>
      )} */}


      
      {/* Button pushed to bottom */}
      <Button
        variant="primary"
        className="details-btn mt-auto"
        // onClick={() => navigate(`/listing/${listing._id}`)} 
        
        onClick = {() => navigate(`/listings/${listing.slug}`)}
      >
        View Details
      </Button>
    </Card.Body>
  </Card>
</Col>
      )

})
  )}
</Row>
        </Col>
      </Row>
      

      {/* {totalPages > 1 && (
        <div className="directory-pagination">
          {[...Array(totalPages)].map((_, idx) => (
            <button
              key={idx}
              className={`pagination-btn${page === idx + 1 ? ' active' : ''}`}
              onClick={() => handlePageChange(idx + 1)}
            >
              {idx + 1}
            </button>
          ))}
        </div>
      )} */}
      {totalPages > 1 && (
        <ReactPaginate
          pageCount={totalPages}
          onPageChange={handlePageClick}
          containerClassName="pagination justify-content-center mt-4"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousLabel="«"
          nextLabel="»"
          previousClassName="page-item"
          nextClassName="page-item"
          previousLinkClassName="page-link"
          nextLinkClassName="page-link"
          activeClassName="active"
          breakLabel="..."
          marginPagesDisplayed={1}
          pageRangeDisplayed={3}
        />
      )}
      {/* <div className="directory-header">
        <h2>
          {selectedCategory ? selectedCategory.charAt(0).toUpperCase() + selectedCategory.slice(1) : "All"} Services Directory
        </h2>
        <p>Browse top-rated pet services by category and city</p>
      </div>
      <div className="directory-filters">
        <select value={selectedCategory} onChange={handleCategoryChange}>
          <option value="">All Categories</option>
          {categories.map(cat => (
            <option value={cat} key={cat}>{cat.charAt(0).toUpperCase() + cat.slice(1)}</option>
          ))}
        </select>
        <select value={selectedCity} onChange={handleCityChange}>
          <option value="">All Cities</option>
          {cities.map(city => (
            <option value={city} key={city}>{city}</option>
          ))}
        </select>
        <input
          type="text"
          placeholder="Search by name, type, or location"
          value={search}
          onChange={handleSearchChange}
        />
      </div>
      <div className="directory-listings">
        {paginatedListings.length === 0 ? (
          <div className="no-results">No listings found.</div>
        ) : (
          paginatedListings.map(listing => (
            <div className="directory-card" key={listing.id}>
              <div className="directory-card-header">
                <h3>{listing.name}</h3>
                <span className="directory-type">{listing.type}</span>
              </div>
              <div className="directory-location">{listing.location} <span className="directory-city">({listing.city})</span></div>
              <div className="directory-description">{listing.description}</div>
              <button className="view-details-btn">View Details</button>
            </div>
          ))
        )}
      </div>
      {totalPages > 1 && (
        <div className="directory-pagination">
          {[...Array(totalPages)].map((_, idx) => (
            <button
              key={idx}
              className={`pagination-btn${page === idx + 1 ? ' active' : ''}`}
              onClick={() => handlePageChange(idx + 1)}
            >
              {idx + 1}
            </button>
          ))}
        </div>
      )} */}
      </Container>
    </section>
    {/* {bottomHomeAds.length > 0 && (
        <div className='footer-ads'>
          <Container>
            <AdSlider ads={bottomHomeAds} maxImages={adSettings.maxImages} interval={adSettings.slideInterval} />
          </Container>
        </div>
      )} */}
      {banner?.content && (
        <section className="city-banner-content py-4">
          <Container>
            <div
              className="city-content-box"
              dangerouslySetInnerHTML={{ __html: banner.content }}
            />
          </Container>
        </section>
      )}
      {routeCity ? (

bottomCityAds.length > 0 &&
<AdSlider
 ads={bottomCityAds}
 maxImages={adSettings.maxImages}
 interval={adSettings.slideInterval}
/>

):(

bottomHomeAds.length > 0 &&
<AdSlider
 ads={bottomHomeAds}
 maxImages={adSettings.maxImages}
 interval={adSettings.slideInterval}
/>

)}
      </>
  );
};

export default Directory;